import { privateAxios } from "./Helper";


export const mailServiceSubmit = (mailData) =>{
    console.log(mailData);

    return privateAxios.post('mail_data_save',mailData).then((response) => response.data);

}